import React, { useState } from 'react'
import { useTranslation } from '../../../../../common/hooks'
import {
  ConfirmDialog,
  ConfirmDialogValue,
} from '../../../../../common/components'
import { UsePatientsListReturn } from '../../../../../common/hooks/usePatientsList'
import { useDeleteReferral } from '../../hooks/useDeleteReferral'
import { GeneralActionButton } from '../../../../../common/components/BetmenList/BetmenListActions'
import { Delete as DeleteIcon } from '@mui/icons-material'

interface DeleteReferralButtonProps
  extends Pick<UsePatientsListReturn, 'refetch'> {
  referralId: string
}
export const DeleteReferralButton: React.FC<DeleteReferralButtonProps> = ({
  refetch,
  referralId,
}) => {
  const { t } = useTranslation()

  const [confirmDeleteModal, setConfirmDeleteModal] =
    useState<ConfirmDialogValue>(false)
  const [deleteReferral] = useDeleteReferral()

  const handleDelete = async () => {
    await deleteReferral({
      variables: {
        referralId,
      },
      onCompleted: () => {
        refetch()
      },
    })
  }

  return (
    <>
      <GeneralActionButton
        tooltipKey="common:delete"
        click={() => setConfirmDeleteModal(true)}
        icon={<DeleteIcon />}
        color="error"
      />

      {confirmDeleteModal && (
        <ConfirmDialog
          isAlertingDialog
          valueState={[confirmDeleteModal, setConfirmDeleteModal]}
          title={t(`patients:confirmDeleteReferralTitle`)}
          text={t(`patients:confirmDeleteReferralDescription`)}
          onAccept={() => handleDelete()}
          acceptButtonTitle={t('patients:confirmDeleteReferralButton')}
        />
      )}
    </>
  )
}
